/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Bo as Bo,
  rec_Componente_rDolar_114_36 as Componente_rDolar_114_36,
  rec_JSXRuntime as JSXRuntime,
  rec_MQ as MQ,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_c$ as c$,
} from "../../runtime/index.jsx";
export function Componente_sDolar_115_36(e) {
  let t = (0, ReactCompiler.c)(19),
    { titulo: n, vacio: r, filas: i, columna: a, tono: o, nota: s } = e,
    c = s !== void 0 && s,
    l,
    u;
  t[0] === i
    ? ((l = t[1]), (u = t[2]))
    : ((l = i ?? []),
      (u = Math.max(...l.map(c$), 0)),
      (t[0] = i),
      (t[1] = l),
      (t[2] = u));
  let d = u,
    f;
  t[3] === n
    ? (f = t[4])
    : ((f = <p className={`font-medium text-(--text-h)`} children={n} />),
      (t[3] = n),
      (t[4] = f));
  let p;
  t[5] !== a ||
  t[6] !== l ||
  t[7] !== d ||
  t[8] !== c ||
  t[9] !== o ||
  t[10] !== r
    ? ((p =
        l.length === 0 ? (
          <p className={`text-sm text-(--text)`} children={r} />
        ) : (
          <table
            className={`w-full text-left text-sm`}
            children={
              <tbody
                children={l.map((e) => (
                  <tr
                    key={e.etiqueta}
                    className={`border-t border-(--border)/50 first:border-0`}
                    children={[
                      <td
                        className={`max-w-0 py-1.5 pr-2`}
                        children={[
                          <span
                            className={`block truncate text-(--text-h)`}
                            children={e.etiqueta}
                          />,
                          e.detalle && (
                            <span
                              className={`block truncate text-xs text-(--text)`}
                              children={e.detalle}
                            />
                          ),
                        ]}
                      />,
                      <td
                        className={`w-24 py-1.5 pr-2`}
                        children={
                          <Componente_rDolar_114_36
                            parte={e.veces}
                            total={d}
                            tono={o}
                          />
                        }
                      />,
                      <td
                        className={`w-20 py-1.5 pr-2 whitespace-nowrap text-right text-xs text-(--text)`}
                        children={[
                          e.veces,
                          ` `,
                          e.veces === 1 ? `vez` : `veces`,
                          e.personas > 0 && ` · ${e.personas}`,
                        ]}
                      />,
                      a && (
                        <td
                          className={`w-24 py-1.5 whitespace-nowrap text-right text-(--text-h)`}
                          children={
                            c
                              ? `${Number(e.monto).toFixed(1)} / 5`
                              : MQ(e.monto)
                          }
                        />
                      ),
                    ]}
                  />
                ))}
              />
            }
          />
        )),
      (t[5] = a),
      (t[6] = l),
      (t[7] = d),
      (t[8] = c),
      (t[9] = o),
      (t[10] = r),
      (t[11] = p))
    : (p = t[11]);
  let m;
  t[12] !== a || t[13] !== l.length
    ? ((m = a && l.length > 0 && (
        <p
          className={`text-right text-[10px] uppercase text-(--text)`}
          children={a}
        />
      )),
      (t[12] = a),
      (t[13] = l.length),
      (t[14] = m))
    : (m = t[14]);
  let h;
  return (
    t[15] !== f || t[16] !== p || t[17] !== m
      ? ((h = (
          <section
            className={`${Bo} flex flex-col gap-2`}
            children={[f, p, m]}
          />
        )),
        (t[15] = f),
        (t[16] = p),
        (t[17] = m),
        (t[18] = h))
      : (h = t[18]),
    h
  );
}
